// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import BankFilledSvg from "@ant-design/icons-svg/es/asn/BankFilled";
import AntdIcon from '../components/AntdIcon';

var BankFilled = function BankFilled(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: BankFilledSvg
  }));
};

BankFilled.displayName = 'BankFilled';
export default React.forwardRef(BankFilled);


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@ant-design_icons@4.0.6@@ant-design/icons/es/icons/BankFilled.js
// module id = 617
// module chunks = 0